import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import {
  Form,
  Row,
  Col,
  Select,
  Typography,
} from 'antd';

import SimpleFormModal from '../../common/modals/SimpleFormModal';
import OnTraccrTextInput from '../../common/inputs/OnTraccrTextInput';
import OnTraccrNumberInput from '../../common/inputs/OnTraccrNumberInput';

const RENEWAL_UNIT_OPTIONS = [
  { value: 'days', label: 'Days' },
  { value: 'months', label: 'Months' },
  { value: 'years', label: 'Years' },
];

export default function CertificationTypeModal({
  title,
  visible,
  onClose,
  onSave,
  form,
}) {
  const onRenewalPeriodChange = useCallback((value) => {
    if (value == null) {
      form.setFieldsValue({
        renewalPeriod: null,
        renewalPeriodUnit: null,
      });
    }
  }, [form]);

  return (
    <SimpleFormModal
      title={title}
      visible={visible}
      onSave={onSave}
      onClose={onClose}
      width={560}
    >
      <Form form={form} layout="vertical" style={{ width: '100%' }}>
        <Form.Item
          name="name"
          label="Name"
          rules={[{ required: true, message: 'Name is required' }]}
        >
          <OnTraccrTextInput placeholder="Enter Name" />
        </Form.Item>
        <Form.Item label="Renewal">
          <Row gutter={12}>
            <Col span={12}>
              <Form.Item name="renewalPeriod" noStyle>
                <OnTraccrNumberInput
                  min={1}
                  placeholder="Period"
                  style={{ width: '100%' }}
                  onChange={onRenewalPeriodChange}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item name="renewalPeriodUnit" noStyle>
                <Select
                  allowClear
                  placeholder="Unit"
                  options={RENEWAL_UNIT_OPTIONS}
                  style={{ width: '100%' }}
                />
              </Form.Item>
            </Col>
          </Row>
          <Typography.Text type="secondary" style={{ fontSize: 12 }}>
            Leave blank if this certification does not expire
          </Typography.Text>
        </Form.Item>
      </Form>
    </SimpleFormModal>
  );
}

CertificationTypeModal.propTypes = {
  title: PropTypes.string.isRequired,
  visible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  form: PropTypes.shape({
    setFieldsValue: PropTypes.func,
  }).isRequired,
};
